
import CSearchList from '@/components/c-search-list'
import CTable from '@/components/c-table'
import EditDialog from './components/edit.vue'
import { getIndexConfig, getTableConfig } from './config'
import { getList } from './api'
import { defineComponent, reactive, toRefs, onMounted } from 'vue'

export default defineComponent({
  name: 'system-notification',
  components: {
    CSearchList,
    CTable,
    EditDialog
  },
  setup() {
    const data = reactive({
      ...getIndexConfig(),
      editVisible: false,
      rowData: {}
    })

    const tableConfig = reactive({
      ...getTableConfig()
    })

    const getListFn = () => {
      const params = {
        noticeType: data.queryForm.type,
        state: data.queryForm.status,
        content: data.queryForm.content,
        currPage: tableConfig.pagination.currentPage,
        pageSize: tableConfig.pagination.pageSize
      }
      tableConfig.loading = true
      getList(params).then((res: any) => {
        if (res.data) {
            tableConfig.data = res.data.list || []
            tableConfig.pagination.total = res.data.total || 0
        }
      }).finally(() => {
        tableConfig.loading = false
      })
    }

    const handleSearch = (params: any) => {
      data.queryForm = { ...params }
      tableConfig.pagination.currentPage = 1
      getListFn()
    }

    const handleReset = (params: any) => {
      data.queryForm = params
      tableConfig.pagination.currentPage = 1
      getListFn()
    }

    const pageCurrentChange = (val: number) => {
      tableConfig.pagination.currentPage = val
      getListFn()
    }

    const pageSizeChange = (val: number) => {
      tableConfig.pagination.currentPage = 1
      tableConfig.pagination.pageSize = val
      getListFn()
    }

    const addOrUpdateHandle = (row?: any) => {
      data.rowData = row || {}
      data.editVisible = true
    }

    onMounted(() => {
      getListFn()
    })

    return {
      ...toRefs(data),
      tableConfig,
      handleSearch,
      handleReset,
      pageCurrentChange,
      pageSizeChange,
      addOrUpdateHandle,
      getList: getListFn
    }
  }
})
